/** Privacy Policy page content — /privacy-policy */

import { pageRoute, appRoute } from "./paths.js";

export const privacyPage = {
  documentTitle: "Taldel — Privacy Policy",
  eyebrow: "Legal",
  title: "Privacy Policy",
  subtitle:
    "How Taldel collects, uses, and protects information when you visit our site or work with our teams.",
  lastUpdated: "August 11, 2026",
  contactEmail: "hello@taldel.com",
  sections: [
    {
      heading: "1. Who we are",
      body: "Taldel (“Taldel,” “we,” “us,” or “our”) provides offshore engineering, product, and AI delivery services for startups and growing businesses. This Privacy Policy explains how we handle personal information in connection with our websites, contact forms, and related client or candidate communications.",
    },
    {
      heading: "2. Information we collect",
      body: "We may collect information you provide directly, such as your name, email address, company name, phone number, role, and the details you include in forms or messages. We may also collect limited technical data automatically, including IP address, browser type, device information, pages visited, and referring URLs, through standard web logs and analytics tools.",
    },
    {
      heading: "3. How we use information",
      body: "We use personal information to respond to inquiries, schedule conversations, deliver services under client agreements, evaluate partnership or hiring interest, improve our website and operations, and meet legal or contractual obligations. We do not sell personal information.",
    },
    {
      heading: "4. Cookies and similar technologies",
      body: "Our site may use cookies or similar technologies for essential functionality, performance measurement, and to understand how visitors use the site. You can control cookies through your browser settings. Disabling certain cookies may affect site features.",
    },
    {
      heading: "5. Sharing of information",
      body: "We may share information with service providers who help us operate our business (for example hosting, analytics, email, or CRM tools), with professional advisors when needed, or when required by law. We require vendors who process personal information on our behalf to protect it appropriately. We may also share information in connection with a corporate transaction such as a merger or acquisition.",
    },
    {
      heading: "6. Data retention",
      body: "We retain personal information only as long as needed for the purposes described in this policy, including to maintain business records, resolve disputes, and comply with legal requirements. Retention periods vary depending on the type of information and our relationship with you.",
    },
    {
      heading: "7. Security",
      body: "We use reasonable administrative, technical, and organizational measures designed to protect personal information. No method of transmission or storage is completely secure, and we cannot guarantee absolute security.",
    },
    {
      heading: "8. Your choices and rights",
      body: "Depending on your location, you may have rights to access, correct, delete, or restrict certain personal information, or to object to certain processing. To make a request, contact us at hello@taldel.com. We may need to verify your identity before responding. You may also unsubscribe from marketing emails using the link in those messages.",
    },
    {
      heading: "9. International transfers",
      body: "Taldel may process information in countries other than where you live. Where we transfer personal information internationally, we take steps intended to provide appropriate safeguards consistent with applicable law.",
    },
    {
      heading: "10. Children’s privacy",
      body: "Our services and website are not directed to children under 16, and we do not knowingly collect personal information from them. If you believe a child has provided us information, contact us and we will take appropriate steps to delete it.",
    },
    {
      heading: "11. Changes to this policy",
      body: "We may update this Privacy Policy from time to time. When we do, we will revise the “Last updated” date above. Continued use of our site or services after changes become effective means you acknowledge the updated policy.",
    },
    {
      heading: "12. Contact us",
      body: "Questions about this Privacy Policy or our privacy practices can be sent to hello@taldel.com. We will do our best to respond promptly.",
    },
  ],
  related: {
    label: "Also see",
    href: pageRoute("terms-and-conditions"),
    linkLabel: "Terms & Conditions",
  },
  homeHref: appRoute("hero"),
};

export function getPrivacyPage() {
  return privacyPage;
}

export function privacyRoute(section = "") {
  return pageRoute("privacy-policy", section);
}
